module.exports = __webpack_public_path__ + "static/media/rank3.ceb00854.svg";